/*
 * サブシステム名：
 * 機能名：配車表入力
 * 表示項目カスタマイズ(鍛代商事様向け)
 */
import D2PLMD1010 from '@/views/PLM/D2PLMD1010.js'
import date from '@/ddv2.library/date'
import indexeddb from '@/ddv2.library/indexeddb'
// import filter from '@/rahmen/utils/filters'

export default {
  extends: D2PLMD1010,
  name: 'HaishaMeisaiListEditCustomForKti',
  data: () => ({
    unkoYmdMultiFlg: true,
    conditionDetails: [
      { key: 'seikyuYoteiYmdFromTo', name: '請求計上日', value: 'seikyuYoteiYmdFromTo', delete: false },
      { key: 'haishahyoCd', name: '配車表', value: 'haishahyoNm', delete: true },
      { key: 'haishaEigyoshoId', name: '配車営業所', value: 'haishaEigyoshoNm', delete: true },
      { key: 'sharyoId', name: '車両', value: 'sharyoNm', delete: true },
      { key: 'jininId1', name: '乗務員', value: 'jininNm1', delete: true },
      { key: 'tokuisakiId', name: '得意先', value: 'tokuisakiNm', delete: true }
    ]
  }),
  watch: {
    /**
     * 検索条件簡易表示用
     * @param {} n
     */
    // 請求計上日From
    'conditions.seikyuYoteiYmdFrom': function (n) {
      var seikyuYoteiYmdFromTo = ![undefined, null, ''].includes(this.conditions.seikyuYoteiYmdFrom) ? this.conditions.seikyuYoteiYmdFrom.slice(-5) : ''
      seikyuYoteiYmdFromTo = seikyuYoteiYmdFromTo + (![undefined, null, ''].includes(this.conditions.seikyuYoteiYmdTo) ? '～' + this.conditions.seikyuYoteiYmdTo.slice(-5) : '')
      this.conditions.seikyuYoteiYmdFromTo = seikyuYoteiYmdFromTo
    },
    // 請求計上日To
    'conditions.seikyuYoteiYmdTo': function (n) {
      var seikyuYoteiYmdFromTo = ![undefined, null, ''].includes(this.conditions.seikyuYoteiYmdFrom) ? this.conditions.seikyuYoteiYmdFrom.slice(-5) : ''
      seikyuYoteiYmdFromTo = seikyuYoteiYmdFromTo + (![undefined, null, ''].includes(this.conditions.seikyuYoteiYmdTo) ? '～' + this.conditions.seikyuYoteiYmdTo.slice(-5) : '')
      this.conditions.seikyuYoteiYmdFromTo = seikyuYoteiYmdFromTo
    }
  },
  computed: {
  },
  methods: {
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const d = new Date()
      const initConditions = {
        seikyuYoteiYmdFrom: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        seikyuYoteiYmdTo: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
        haishaEigyoshoId: this.eigyoshoReadOnly ? indexeddb.getRecordByCd(this.currentKaishaCode, this.filteredEigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, date.getCurrentDate()).id : null,
        haishahyoCd: null,
        eigyoshoId: null,
        tokuisakiId: null,
        layoutType: 'D2PLMD1011'
      }
      this.conditions = {
        ...initConditions,
        // 表示用
        seikyuYoteiYmdFromTo: initConditions.seikyuYoteiYmdFrom + '～' + initConditions.seikyuYoteiYmdTo,
        haishahyoNm: null,
        haishaEigyoshoNm: null,
        sharyoNm: null,
        jomuinNm: null
      }
      this.isAfterSearch = false
      this.haishaChohyoSbt = '0'
      this.nohinshoChohyoSbt = '99'
      this.searchText = ''
      this.rows = []
      this.searchResultList = []
      this.page = 1
    },
    // 固有カスタマイズ：保存時に請求備考(seikyuBiko)を支払備考(shiharaiBiko)に設定する
    saveAction: function () {
      this.targetList.forEach((elem) => {
        if (![undefined, null, ''].includes(elem.seikyuBiko)) {
          elem.shiharaiBiko = elem.seikyuBiko
        }
      })
      D2PLMD1010.methods.saveAction.call(this)
    }
  }
}
